import {
	FETCH_PATIENT_PROFILE,
	FETCH_PATIENT_PROFILE_SUCCESS,
	FETCH_PATIENT_PROFILE_ERROR,
	FETCH_PATIENT_CALENDAR,
	FETCH_PATIENT_CALENDAR_SUCCESS,
	FETCH_PATIENT_CALENDAR_ERROR,
	FETCH_PATIENT_GROUPS,
	FETCH_PATIENT_GROUPS_SUCCESS,
	FETCH_PATIENT_GROUPS_ERROR,
	FETCH_PATIENT_OQ,
	FETCH_PATIENT_OQ_SUCCESS,
	FETCH_PATIENT_OQ_ERROR,
} from './constants';

export const fetchPatientProfile = (patientId) => ({ type: FETCH_PATIENT_PROFILE, patientId });
export const fetchPatientProfileSuccess = (data) => ({ type: FETCH_PATIENT_PROFILE_SUCCESS, data });
export const fetchPatientProfileError = (error) => ({ type: FETCH_PATIENT_PROFILE_ERROR, error });

export const fetchPatientCalendar = (patientId) => ({ type: FETCH_PATIENT_CALENDAR, patientId });
export const fetchPatientCalendarSuccess = (data) => ({ type: FETCH_PATIENT_CALENDAR_SUCCESS, data });
export const fetchPatientCalendarError = (error) => ({ type: FETCH_PATIENT_CALENDAR_ERROR, error });

export const fetchPatientGroups = (patientId) => ({ type: FETCH_PATIENT_GROUPS, patientId });
export const fetchPatientGroupsSuccess = (data) => ({ type: FETCH_PATIENT_GROUPS_SUCCESS, data });
export const fetchPatientGroupsError = (error) => ({ type: FETCH_PATIENT_GROUPS_ERROR, error });

export const fetchPatientOq = (patientId) => ({ type: FETCH_PATIENT_OQ, patientId });
export const fetchPatientOqSuccess = (data) => ({ type: FETCH_PATIENT_OQ_SUCCESS, data });
export const fetchPatientOqError = (error) => ({ type: FETCH_PATIENT_OQ_ERROR, error });
